<div class="row">
    <div class="col-12 col-sm-6">
        <form-floating>
            <label i18n="@@addressDetails_postal_label" app-i18n="addressDetails_postal_label">Postcode *</label>
            <input
                [formControl]="formAddress.get('postal')"
                type="text"
                class="form-control"
                placeholder="Postcode"
                i18n-placeholder="@@addressDetails_postal_place"
                [attr.placeholder]="i18n('addressDetails_postal_place')"
                (blur)="addressBlur.emit($event)"
                data-cy="postal"
                input-validation
            />

            <ng-container *ngIf="formAddress.get('city').disabled">
                <button *ngIf="postalLoading" class="btn btn-outline-secondary">
                    <fa-icon [icon]="['fal', 'spinner-third']" [fixedWidth]="true" [animation]="'spin'"></fa-icon>
                </button>
                <button
                    *ngIf="!postalLoading"
                    class="btn btn-outline-info"
                    (click)="postalUserDontKnow.emit($event); $event.stopPropagation()"
                    tippy
                    i18n-data-tippyOptionsContent="@@addressDetails_postal_unknown"
                    data-tippyOptionsContent="Ik weet mijn postcode niet"
                    [tippyOptions]="{ content: i18n('addressDetails_postal_unknown') }"
                >
                    <fa-icon [icon]="['fal', 'question-circle']" [fixedWidth]="true"></fa-icon>
                </button>
            </ng-container>
        </form-floating>
    </div>
    <div class="col-12 col-sm-3">
        <form-floating>
            <label i18n="@@addressDetails_streetNumber_label" app-i18n="addressDetails_streetNumber_label">Huisnummer *</label>
            <input
                [formControl]="formAddress.get('number')"
                class="form-control"
                type="text"
                placeholder="Nummer"
                i18n-placeholder="@@addressDetails_streetNumber_place"
                [attr.placeholder]="i18n('addressDetails_streetNumber_place')"
                (blur)="addressBlur.emit($event)"
                data-cy="number"
                input-validation
            />
        </form-floating>
    </div>
    <div class="col-12 col-sm-3">
        <form-floating>
            <label i18="@@addressDetails_streetAddition_place" app-i18n="addressDetails_streetAddition_place">Toevoeging</label>
            <input
                [formControl]="formAddress.get('addition')"
                class="form-control"
                type="text"
                placeholder="Toevoeging"
                i18n-placeholder="@@addressDetails_streetAddition_place"
                [attr.placeholder]="i18n('addressDetails_streetAddition_place')"
                data-cy="addition"
                input-validation
            />
        </form-floating>
    </div>
</div>
<div class="row">
    <div class="col-12 col-sm-6">
        <form-floating>
            <label i18n="@@addressDetails_city_label" app-i18n="addressDetails_city_label">Stad *</label>
            <input
                [formControl]="formAddress.get('city')"
                class="form-control"
                type="text"
                placeholder="Stad"
                i18n-placeholder="@@addressDetails_city_place"
                [attr.placeholder]="i18n('addressDetails_city_place')"
                data-cy="city"
                input-validation
            />
        </form-floating>
    </div>
    <div class="col-12 col-sm-6">
        <form-floating>
            <label i18n="@@addressDetails_streetName_label" app-i18n="addressDetails_streetName_label">Straatnaam *</label>
            <input
                [formControl]="formAddress.get('street')"
                class="form-control"
                type="text"
                placeholder="Straatnaam"
                i18n-placeholder="@@addressDetails_streetName_place"
                [attr.placeholder]="i18n('addressDetails_streetName_place')"
                data-cy="street"
                input-validation
            />
        </form-floating>
    </div>
</div>
